import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap/dist/css/bootstrap.css';
import 'katex/dist/katex.min.css';
import '@project/index.css';
import '@project/assets/styles/global.scss';
import '@project/assets/styles/override.boostrap.scss';
import '@project/assets/styles/override.suneditor.scss';
import '@project/assets/nucleo-icons/scss/icons.scss';
import App from '@project/App';
import reportWebVitals from '@project/reportWebVitals';
import { setupStore } from '@store/store';

//set-up store
const store = setupStore();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
